<template>
  <custom-dropdown-group group-header="Keywords">
    <template v-slot:group-content>
      <v-flex xs12>
        <input
          type="text"
          placeholder="Enter keywords..."
          class="search-keyword-input"
          :value="initialKeywords"
          @keyup.enter="$emit('update-keyword', $event.target.value)"
          @input="$emit('update-keyword', $event.target.value)"
        >
      </v-flex>
      <!-- <v-flex xs4>
        <v-btn id="addKeywordBtn" outline @click.stop="addKeyword">
          ADD
        </v-btn>
      </v-flex> -->
    </template>
  </custom-dropdown-group>
</template>

<script>
import CustomDropdownGroup from '../../common/search/CustomDropdownGroup.vue'
export default {
  components: { CustomDropdownGroup },

  props: {
    initialKeywords: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="sass" scoped>
.search-keyword-input
  border-radius: 0.5rem
  padding: 0.7rem
  border: 1px solid $hwayzBlack
  font-size: 1.4rem
  margin: 6px 8px

#addKeywordBtn
  border-radius: 0.5rem
</style>
